<template>
  <div class="view-home">
    <div class="container">
      <div class="quiz-status my-4">
        <div class="card" v-show="countdown">
          <ul>
            <li class="time">
              {{ countdown }}
            </li>
            <li class="recording" v-if="quiz.proctoring">
              {{ $t('testing.recording') }}
            </li>
            <li class="interruption" v-if="quiz.proctoring">
              {{ $t('testing.interruption') }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="container questions-wrap" v-if="this.$i18n.locale == 'ru'">
      <h2>
        Коллаборация
      </h2>
      <h3>
        {{ $t('collaboration.title') }}
      </h3>
      <div class="collaboration-desc">
        <strong>Инструкция</strong>: «Уважаемые участники, вам представлен опросник с незаконченными предложениями,
        касающиеся Вашего интереса к той или иной профессии. Прочитайте их и закончите, выбрав 3 варианта ответов по
        степени их значимости.
        У вас есть на выполнение всех заданий не более <strong>20 минут</strong>».
      </div>

      <div class="d-flex flex-column">
        <div :style="{ order: orderQuestions[0] }">
          <p>{{orderQuestions[0]}}{{ $t('collaboration.question-1') }}</p>
          <p>1)
            <el-select v-model="selectProf[0].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  :label="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
              >
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'"
                >
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[1].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  :label="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
              >
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[2].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  :label="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
              >
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[1] }">
          <p>{{orderQuestions[1]}}{{ $t('collaboration.question-2') }}</p>
          <p>1)
            <el-select v-model="selectProf[3].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  :label="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
              >
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[4].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[5].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[2] }">
          <p>{{orderQuestions[2]}}{{ $t('collaboration.question-3') }}</p>
          <p>1)
            <el-select v-model="selectProf[6].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[7].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[8].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[3] }">
          <p>{{orderQuestions[3]}}{{ $t('collaboration.question-4') }}</p>
          <p>1)
            <el-select v-model="selectProf[9].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[10].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[11].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[4] }">
          <p>{{orderQuestions[4]}}{{ $t('collaboration.question-5') }}</p>
          <p>1)
            <el-select v-model="selectProf[12].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[13].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[14].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[5] }">
          <p>{{orderQuestions[5]}}{{ $t('collaboration.question-6') }}</p>
          <p>1)
            <el-select v-model="selectProf[15].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[16].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[17].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[6] }">
          <p>{{orderQuestions[6]}}{{ $t('collaboration.question-7') }}</p>
          <p>1)
            <el-select v-model="selectProf[18].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[19].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[20].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[7] }">
          <p>{{orderQuestions[7]}}{{ $t('collaboration.question-8') }}</p>
          <p>1)
            <el-select v-model="selectProf[21].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[22].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[23].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[8] }">
          <p>{{orderQuestions[8]}}{{ $t('collaboration.question-9') }}</p>
          <p>1)
            <el-select v-model="selectProf[24].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[25].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[26].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[9] }">
          <p>{{orderQuestions[9]}}{{ $t('collaboration.question-10') }}</p>
          <p>1)
            <el-select v-model="selectProf[27].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[28].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[29].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[10] }">
          <p>{{orderQuestions[10]}}{{ $t('collaboration.question-11') }}</p>
          <p>1)
            <el-select v-model="selectProf[30].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[31].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[32].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[11] }">
          <p>{{orderQuestions[11]}}{{ $t('collaboration.question-12') }}</p>
          <p>1)
            <el-select v-model="selectProf[33].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[34].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[35].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[12] }">
          <p>{{orderQuestions[12]}}{{ $t('collaboration.question-13') }}</p>
          <p>1)
            <el-select v-model="selectProf[36].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[37].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[38].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[13] }">
          <p>{{orderQuestions[13]}}{{ $t('collaboration.question-14') }}</p>
          <p>1)
            <el-select v-model="selectProf[39].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[40].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[41].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaboration"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
      </div>

<!--      <button @click="sendCollaborationResults">Отправить</button>-->
      <el-button @click="openModal"
                 class="btn btn-danger">{{ $t('testing.finish-modal-button') }}
      </el-button>

    </div>


    <div class="container questions-wrap"  v-if="this.$i18n.locale == 'kz'">
      <h2>
        Коллаборация
      </h2>
      <h3>
        {{ $t('collaboration.title') }}
      </h3>
      <div class="collaboration-desc">
        <strong>Нұсқау</strong>: «Құрметті қатысушылар, сіздерге белгілі бір мамандыққа деген қызығушылықтарыңызға қатысты аяқталмаған
        сөйлемдері бар сауалнама ұсынылады. Оларды оқып, маңыздылығына қарай 3 жауапты таңдау арқылы аяқтаңыз.
        Барлық тапсырмаларды орындауға <strong>20 минут</strong> уақыт беріледі».
      </div>

      <div class="d-flex flex-column">
        <div :style="{ order: orderQuestions[0] }">
          <p>{{ orderQuestions[0] }}{{ $t('collaboration.question-1') }}</p>
          <p>1)
            <el-select v-model="selectProf[0].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  :label="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
              >
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'"
                >
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[1].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  :label="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
              >
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[2].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  :label="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
              >
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[1] }">
          <p>{{ orderQuestions[1] }}{{ $t('collaboration.question-2') }}</p>
          <p>1)
            <el-select v-model="selectProf[3].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  :label="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
              >
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[4].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[5].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[2] }">
          <p>{{ orderQuestions[2] }}{{ $t('collaboration.question-3') }}</p>
          <p>1)
            <el-select v-model="selectProf[6].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[7].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[8].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[3] }">
          <p>{{ orderQuestions[3] }}{{ $t('collaboration.question-4') }}</p>
          <p>1)
            <el-select v-model="selectProf[9].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[10].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[11].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[4] }">
          <p>{{ orderQuestions[4] }}{{ $t('collaboration.question-5') }}</p>
          <p>1)
            <el-select v-model="selectProf[12].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[13].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[14].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[5] }">
          <p>{{ orderQuestions[5] }}{{ $t('collaboration.question-6') }}</p>
          <p>1)
            <el-select v-model="selectProf[15].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[16].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[17].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[6] }">
          <p>{{ orderQuestions[6] }}{{ $t('collaboration.question-7') }}</p>
          <p>1)
            <el-select v-model="selectProf[18].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[19].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[20].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[7] }">
          <p>{{ orderQuestions[7] }}{{ $t('collaboration.question-8') }}</p>
          <p>1)
            <el-select v-model="selectProf[21].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[22].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[23].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[8] }">
          <p>{{ orderQuestions[8] }}{{ $t('collaboration.question-9') }}</p>
          <p>1)
            <el-select v-model="selectProf[24].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[25].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[26].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '-1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[9] }">
          <p>{{ orderQuestions[9] }}{{ $t('collaboration.question-10') }}</p>
          <p>1)
            <el-select v-model="selectProf[27].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[28].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[29].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[10] }">
          <p>{{ orderQuestions[10] }}{{ $t('collaboration.question-11') }}</p>
          <p>1)
            <el-select v-model="selectProf[30].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[31].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[32].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[11] }">
          <p>{{ orderQuestions[11] }}{{ $t('collaboration.question-12') }}</p>
          <p>1)
            <el-select v-model="selectProf[33].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[34].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[35].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[12] }">
          <p>{{ orderQuestions[12] }}{{ $t('collaboration.question-13') }}</p>
          <p>1)
            <el-select v-model="selectProf[36].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[37].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[38].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
        <div :style="{ order: orderQuestions[13] }">
          <p>{{ orderQuestions[13] }}{{ $t('collaboration.question-14') }}</p>
          <p>1)
            <el-select v-model="selectProf[39].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+3'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>2)
            <el-select v-model="selectProf[40].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+2'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
          <p>3)
            <el-select v-model="selectProf[41].choice" :placeholder="$t('select')" class="select-custom-collaboration"
                       @click.native="resetActiveChapter">
              <el-option-group
                  v-for="group in optionsCollaborationKZ"
                  :key="group.label"
                  class="collaboration-options"
                  @click.native="activeChapter(group.label)"
                  :label="group.label">
                <el-option
                    v-if="group.label == showActiveChapter"
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value + '+1'">
                </el-option>
                <el-option value="none" style="visibility: hidden; height: 0">.</el-option>
              </el-option-group>
            </el-select>
          </p>
        </div>
      </div>

      <!--      <button @click="sendCollaborationResults">Отправить</button>-->
      <el-button @click="openModal"
                 class="btn btn-danger">{{ $t('testing.finish-modal-button') }}
      </el-button>

    </div>

    <b-modal id="exit-modal" hide-footer hide-header>
      <div id="modal-wrapper">
        <div id="dialog">
          <button @click="$bvModal.hide('exit-modal')" type="button" class="close" data-dismiss="modal"
                  aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
          <img class="modal-warning-img mb-3" src="/images/profile/modal-warning.svg">
          <h3 class="mb-0">{{ $t('testing.finish-modal-title') }}</h3>
          <p>{{ $t('testing.finish-modal-desc') }}</p>
          <div class="clearfix pt-3">
            <el-button @click="sendCollaborationResults" class="btn btn-primary mx-2">
              {{ $t('testing.finish-modal-button') }}
            </el-button>
            <a @click="$bvModal.hide('exit-modal')"
               class="btn btn-outline-primary mx-2">{{ $t('testing.finish-modal-cancel') }}</a>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import 'katex/dist/katex.min.css';
import Loader from '../../components/Loader';
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import Vue from 'vue';

Vue.use(VueViewer)
export default {
  name: "Index",
  data() {
    return {
      timerInterval: null,
      showActiveChapter: '',
      countdown: 0,
      quiz: '',
      selectProf: [
        { choice: "", question: "1.1" },
        { choice: "", question: "1.2" },
        { choice: "", question: "1.3" },
        { choice: "", question: "2.1" },
        { choice: "", question: "2.2" },
        { choice: "", question: "2.3" },
        { choice: "", question: "3.1" },
        { choice: "", question: "3.2" },
        { choice: "", question: "3.3" },
        { choice: "", question: "4.1" },
        { choice: "", question: "4.2" },
        { choice: "", question: "4.3" },
        { choice: "", question: "5.1" },
        { choice: "", question: "5.2" },
        { choice: "", question: "5.3" },
        { choice: "", question: "6.1" },
        { choice: "", question: "6.2" },
        { choice: "", question: "6.3" },
        { choice: "", question: "7.1" },
        { choice: "", question: "7.2" },
        { choice: "", question: "7.3" },
        { choice: "", question: "8.1" },
        { choice: "", question: "8.2" },
        { choice: "", question: "8.3" },
        { choice: "", question: "9.1" },
        { choice: "", question: "9.2" },
        { choice: "", question: "9.3" },
        { choice: "", question: "10.1" },
        { choice: "", question: "10.2" },
        { choice: "", question: "10.3" },
        { choice: "", question: "11.1" },
        { choice: "", question: "11.2" },
        { choice: "", question: "11.3" },
        { choice: "", question: "12.1" },
        { choice: "", question: "12.2" },
        { choice: "", question: "12.3" },
        { choice: "", question: "13.1" },
        { choice: "", question: "13.2" },
        { choice: "", question: "13.3" },
        { choice: "", question: "14.1" },
        { choice: "", question: "14.2" },
        { choice: "", question: "14.3"}
      ],
      // selectProf: [
      //   { choice: "1техник+3", question: "1.1" },
      //   { choice: "1металлург+2", question: "1.2" },
      //   { choice: "1рабочий+1", question: "1.3" },
      //   { choice: "1рабочий+3", question: "2.1" },
      //   { choice: "4рыбовод+2", question: "2.2" },
      //   { choice: "5полицейский+1", question: "2.3" },
      //   { choice: "1оператор+3", question: "3.1" },
      //   { choice: "6дизайнер+2", question: "3.2" },
      //   { choice: "4лесник+1", question: "3.3" },
      //   { choice: "5полицейский-3", question: "4.1" },
      //   { choice: "2политолог-2", question: "4.2" },
      //   { choice: "2политолог-1", question: "4.3" },
      //   { choice: "2экскурсовод+3", question: "5.1" },
      //   { choice: "1оператор+2", question: "5.2" },
      //   { choice: "4астроном+1", question: "5.3" },
      //   { choice: "2политолог+3", question: "6.1" },
      //   { choice: "5полицейский+2", question: "6.2" },
      //   { choice: "1оператор+1", question: "6.3" },
      //   { choice: "4астроном+3", question: "7.1" },
      //   { choice: "2политолог+2", question: "7.2" },
      //   { choice: "4лесник+1", question: "7.3" },
      //   { choice: "5полицейский+3", question: "8.1" },
      //   { choice: "2политолог+2", question: "8.2" },
      //   { choice: "2политик+1", question: "8.3" },
      //   { choice: "2политолог-3", question: "9.1" },
      //   { choice: "1оператор-2", question: "9.2" },
      //   { choice: "5полицейский-1", question: "9.3" },
      //   { choice: "4лесник+3", question: "10.1" },
      //   { choice: "2политолог+2", question: "10.2" },
      //   { choice: "4астроном+1", question: "10.3" },
      //   { choice: "4лесник+3", question: "11.1"},
      //   { choice: "1оператор+2", question: "11.2" },
      //   { choice: "6дизайнер+1", question: "11.3" },
      //   { choice: "2политолог+3", question: "12.1" },
      //   { choice: "4лесник+2", question: "12.2" },
      //   { choice: "4лесник+1", question: "12.3" },
      //   { choice: "6дизайнер+3", question: "13.1" },
      //   { choice: "4астроном+2", question: "13.2" },
      //   { choice: "4лесник+1", question: "13.3" },
      //   { choice: "6дизайнер+3", question: "14.1" },
      //   { choice: "3филолог+2", question: "14.2" },
      //   { choice: "", question: "14.3" }
      // ],
      orderQuestions: [],
      selectProfNew: [],
      profId1: [],
      profId2: [],
      profId3: [],
      profId4: [],
      profId5: [],
      profId6: [],
      profId7: [],
      profId1Sum: 0,
      profId2Sum: 0,
      profId3Sum: 0,
      profId4Sum: 0,
      profId5Sum: 0,
      profId6Sum: 0,
      profId7Sum: 0,
      optionsCollaboration: [{
        label: 'Технические',
        options: [
          {value: '1техник', label: 'техник'},
          {value: '1инженер', label: 'инженер'},
          {value: '1металлург', label: 'металлург'},
          {value: '1архитектор', label: 'архитектор'},
          {value: '1строитель', label: 'строитель'},
          {value: '1столяр', label: 'столяр'},
          {value: '1плотник', label: 'плотник'},
          {value: '1рабочий', label: 'рабочий'},
          {value: '1слесарь', label: 'слесарь'},
          {value: '1токарь', label: 'токарь'},
          {value: '1механик', label: 'механик'},
          {value: '1машинист', label: 'машинист'},
          {value: '1водитель', label: 'водитель'},
          {value: '1пилот', label: 'пилот'},
          {value: '1электрик', label: 'электрик'},
          {value: '1энергетик', label: 'энергетик'},
          {value: '1оператор', label: 'оператор'},
          {value: '1IT', label: 'IT'},
          {value: '1программист', label: 'программист'},
        ]
      }, {
        label: 'Социальные',
        options: [
          {value: '2менеджер', label: 'менеджер'},
          {value: '2маркетолог', label: 'маркетолог'},
          {value: '2бизнесмен', label: 'бизнесмен'},
          {value: '2агент', label: 'агент'},
          {value: '2бухгалтер', label: 'бухгалтер'},
          {value: '2продавец', label: 'продавец'},
          {value: '2юрист', label: 'юрист'},
          {value: '2политолог', label: 'политолог'},
          {value: '2дипломат', label: 'дипломат'},
          {value: '2политик', label: 'политик'},
          {value: '2психолог', label: 'психолог'},
          {value: '2журналист', label: 'журналист'},
          {value: '2социолог', label: 'социолог'},
          {value: '2социальный работник', label: 'социальный работник'},
          {value: '2экскурсовод', label: 'экскурсовод'},
          {value: '2администратор', label: 'администратор'},
          {value: '2официант', label: 'официант'},
        ]
      }, {
        label: 'Гуманитарные',
        options: [
          {value: '3филолог', label: 'филолог'},
          {value: '3переводчик', label: 'переводчик'},
          {value: '3историк', label: 'историк'},
          {value: '3архивист', label: 'архивист'},
          {value: '3библиотекарь', label: 'библиотекарь'},
        ]
      },{
        label: 'Естественно-научные и технологии',
        options: [
          {value: '4Биолог', label: 'Биолог'},
          {value: '4химик', label: 'химик'},
          {value: '4математик', label: 'математик'},
          {value: '4геолог', label: 'геолог'},
          {value: '4географ', label: 'географ'},
          {value: '4астроном', label: 'астроном'},
          {value: '4агроном', label: 'агроном'},
          {value: '4садовод', label: 'садовод'},
          {value: '4овощевод', label: 'овощевод'},
          {value: '4животновод', label: 'животновод'},
          {value: '4птицевод', label: 'птицевод'},
          {value: '4рыбовод', label: 'рыбовод'},
          {value: '4пчеловод', label: 'пчеловод'},
          {value: '4эколог', label: 'эколог'},
          {value: '4лесник', label: 'лесник'},
          {value: '4егерь', label: 'егерь'},
          {value: '4фермер', label: 'фермер'},
          {value: '4врач', label: 'врач'},
          {value: '4ветеринар', label: 'ветеринар'},
          {value: '4технолог', label: 'технолог'},
          {value: '4повар', label: 'повар'},
          {value: '4пекарь', label: 'пекарь'},
          {value: '4кондитер', label: 'кондитер'},
          {value: '4швея', label: 'швея'},
          {value: '4портной', label: 'портной'},
          {value: '4парикмахер', label: 'парикмахер'},
        ]
      },{
        label: 'Военно-спортивные',
        options: [
          {value: '5пожарный', label: 'пожарный'},
          {value: '5спасатель', label: 'спасатель'},
          {value: '5военный', label: 'военный'},
          {value: '5полицейский', label: 'полицейский'},
          {value: '5спортсмен', label: 'спортсмен'},
          {value: '5космонавт', label: 'космонавт'},
        ]
      },{
        label: 'Искусство и культура',
          options: [
            {value: '6писатель', label: 'писатель'},
            {value: '6художник', label: 'художник'},
            {value: '6скульптор', label: 'скульптор'},
            {value: '6дизайнер', label: 'дизайнер'},
            {value: '6модельер', label: 'модельер'},
            {value: '6визажист', label: 'визажист'},
            {value: '6артист', label: 'артист'},
            {value: '6музыкант', label: 'музыкант'},
            {value: '6певец', label: 'певец'},
            {value: '6режиссер', label: 'режиссер'},
            {value: '6фотограф', label: 'фотограф'},
            {value: '6оператор', label: 'оператор'},
          ]
        },{
        label: 'Образование',
        options: [
          {value: '7педагог', label: 'педагог'},
        ]
      }
      ],
      optionsCollaborationKZ: [{
        label: 'Техникалық',
        options: [
          {value: '1техник', label: 'техник'},
          {value: '1инженер', label: 'инженер'},
          {value: '1металлург', label: 'металлург'},
          {value: '1архитектор', label: 'архитектор'},
          {value: '1құрылысшы', label: 'құрылысшы'},
          {value: '1ағаш ұстасы', label: 'ағаш ұстасы'},
          {value: '1жұмысшы', label: 'жұмысшы'},
          {value: '1слесарь', label: 'слесарь'},
          {value: '1токарь', label: 'токарь'},
          {value: '1механик', label: 'механик'},
          {value: '1машинист', label: 'машинист'},
          {value: '1жүргізуші', label: 'жүргізуші'},
          {value: '1ұшқыш', label: 'ұшқыш'},
          {value: '1электрик', label: 'электрик'},
          {value: '1энергетик', label: 'энергетик'},
          {value: '1оператор', label: 'оператор'},
          {value: '1IT', label: 'IT'},
          {value: '1программист', label: 'программист'},
        ]
      }, {
        label: 'Әлеуметтік',
        options: [
          {value: '2менеджер', label: 'менеджер'},
          {value: '2маркетолог', label: 'маркетолог'},
          {value: '2бизнесмен', label: 'бизнесмен'},
          {value: '2агент', label: 'агент'},
          {value: '2бухгалтер', label: 'бухгалтер'},
          {value: '2сатушы', label: 'сатушы'},
          {value: '2заңгер', label: 'заңгер'},
          {value: '2саясаттанушы', label: 'саясаттанушы'},
          {value: '2дипломат', label: 'дипломат'},
          {value: '2саясаткер', label: 'саясаткер'},
          {value: '2психолог', label: 'психолог'},
          {value: '2журналист', label: 'журналист'},
          {value: '2әлеуметтанушы', label: 'әлеуметтанушы'},
          {value: '2әлеуметтік қызметкер', label: 'әлеуметтік қызметкер'},
          {value: '2экскурсовод', label: 'экскурсовод'},
          {value: '2әкімші', label: 'әкімші'},
          {value: '2даяшы', label: 'даяшы'},
        ]
      }, {
        label: 'Гуманитарлық',
        options: [
          {value: '3филолог', label: 'филолог'},
          {value: '3аудармашы', label: 'аудармашы'},
          {value: '3тарихшы', label: 'тарихшы'},
          {value: '3архивші', label: 'архивші'},
          {value: '3кітапханашы', label: 'кітапханашы'},
        ]
      },{
        label: 'Жаратылыстану-ғылыми және технологиялық',
        options: [
          {value: '4биолог', label: 'биолог'},
          {value: '4химик', label: 'химик'},
          {value: '4математик', label: 'математик'},
          {value: '4геолог', label: 'геолог'},
          {value: '4географ', label: 'географ'},
          {value: '4астроном', label: 'астроном'},
          {value: '4агроном', label: 'агроном'},
          {value: '4бағбан', label: 'бағбан'},
          {value: '4көкөніс өсіруші', label: 'көкөніс өсіруші'},
          {value: '4мал өсіруші', label: 'мал өсіруші'},
          {value: '4құс өсіруші', label: 'құс өсіруші'},
          {value: '4балық өсіруші', label: 'балық өсіруші'},
          {value: '4омарташы', label: 'омарташы'},
          {value: '4эколог', label: 'эколог'},
          {value: '4орманшы', label: 'орманшы'},
          {value: '4аңшы', label: 'аңшы'},
          {value: '4фермер', label: 'фермер'},
          {value: '4дәрігер', label: 'дәрігер'},
          {value: '4мал дәрігері', label: 'мал дәрігері'},
          {value: '4технолог', label: 'технолог'},
          {value: '4аспаз', label: 'аспаз'},
          {value: '4наубайшы', label: 'наубайшы'},
          {value: '4кондитер', label: 'кондитер'},
          {value: '4тігінші', label: 'тігінші'},
          {value: '4шаштараз', label: 'шаштараз'},
        ]
      },{
        label: 'Әскери-спорттық',
        options: [
          {value: '5өрт сөндіруші', label: 'өрт сөндіруші'},
          {value: '5құтқарушы', label: 'құтқарушы'},
          {value: '5әскери', label: 'әскери'},
          {value: '5полицей', label: 'полицей'},
          {value: '5спортшы', label: 'спортшы'},
          {value: '5космонавт', label: 'космонавт'},
        ]
      },{
        label: 'Өнер және мәдениет',
        options: [
          {value: '6жазушы', label: 'жазушы'},
          {value: '6суретші', label: 'суретші'},
          {value: '6мүсінші', label: 'мүсінші'},
          {value: '6дизайнер', label: 'дизайнер'},
          {value: '6сәнгер', label: 'сәнгер'},
          {value: '6визажист', label: 'визажист'},
          {value: '6әртіс', label: 'әртіс'},
          {value: '6музыкант', label: 'музыкант'},
          {value: '6әнші', label: 'әнші'},
          {value: '6режиссер', label: 'режиссер'},
          {value: '6фотограф', label: 'фотограф'},
          {value: '6оператор', label: 'оператор'},
        ]
      },{
        label: 'Білім беру',
        options: [
          {value: '7педагог', label: 'педагог'},
        ]
      }
      ]
    }
  },
  methods: {
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return array;
    },
    openModal() {
      this.$bvModal.show('exit-modal');
    },
    resetActiveChapter() {
      this.showActiveChapter = ''
    },
    async sendCollaborationResults() {

      this.selectProfNew = [...this.selectProf].map( item => ({ ...item,
        profId: item.choice[0],
        mark: item.choice[item.choice.length - 2] + item.choice[item.choice.length - 1]}))

      this.profId1 = this.selectProfNew.filter(item => item.profId == 1)
      this.profId2 = this.selectProfNew.filter(item => item.profId == 2)
      this.profId3 = this.selectProfNew.filter(item => item.profId == 3)
      this.profId4 = this.selectProfNew.filter(item => item.profId == 4)
      this.profId5 = this.selectProfNew.filter(item => item.profId == 5)
      this.profId6 = this.selectProfNew.filter(item => item.profId == 6)
      this.profId7 = this.selectProfNew.filter(item => item.profId == 7)

      this.profId1Sum = this.profId1.reduce((acc, item) => {
        return acc + Number(item.mark)
      }, 0)
      this.profId2Sum = this.profId2.reduce((acc, item) => {
        return acc + Number(item.mark)
      }, 0)
      this.profId3Sum = this.profId3.reduce((acc, item) => {
        return acc + Number(item.mark)
      }, 0)
      this.profId4Sum = this.profId4.reduce((acc, item) => {
        return acc + Number(item.mark)
      }, 0)
      this.profId5Sum = this.profId5.reduce((acc, item) => {
        return acc + Number(item.mark)
      }, 0)
      this.profId6Sum = this.profId6.reduce((acc, item) => {
        return acc + Number(item.mark)
      }, 0)
      this.profId7Sum = this.profId7.reduce((acc, item) => {
        return acc + Number(item.mark)
      }, 0)

      const quizToken = localStorage.getItem('quiz-token')

      const scoreProfSum = {
        "01" : this.profId1Sum,
        "02" : this.profId2Sum,
        "03" : this.profId3Sum,
        "04" : this.profId4Sum,
        "05" : this.profId5Sum,
        "06" : this.profId6Sum,
        "07" : this.profId7Sum,
      }

      const outputArray = [];
      const outputArrayKZ = [];

      for (const key in scoreProfSum) {
        const value = scoreProfSum[key];
        let profession = key;

        let text = "";
        if (value >= 50 && value <= 72) {
          // text = `<br> У вас выявлен высокий уровень направленности к профессиям "${this.professionalDirections(profession)}"`;
          text = `<br> У вас выявлен высокий уровень направленности к профессиям "${this.professionalDirections(profession, "ru")}"`;
        } else if (value >= 11 && value <= 49) {
          text = `<br> У вас выявлен средний уровень направленности к профессиям "${this.professionalDirections(profession, "ru")}"`;
        } else if (value >= 1 && value <= 10) {
          text = `<br> У вас выявлен низкий уровень направленности к профессиям "${this.professionalDirections(profession, "ru")}"`;
        } else if (value >= -12 && value <= 0) {
          text = `<br> Направленность к профессиям у вас отсутствует "${this.professionalDirections(profession, "ru")}"`;
        }

        outputArray.push(text);
      }

      for (const key in scoreProfSum) {
        const value = scoreProfSum[key];
        let profession = key;

        let text = "";
        if (value >= 50 && value <= 72) {
          // text = `<br> У вас выявлен высокий уровень направленности к профессиям "${this.professionalDirections(profession)}"`;
          text = `<br> Сізде бір мамандыққа бағытталу жоғары деңгейі анықталды "${this.professionalDirections(profession, "kz")}"`;
        } else if (value >= 11 && value <= 49) {
          text = `<br> Сізде бір мамандыққа бағытталу орташа деңгейі анықталды "${this.professionalDirections(profession, "kz")}"`;
        } else if (value >= 1 && value <= 10) {
          text = `<br> Сізде бір мамандыққа бағытталу төмен деңгейі анықталды "${this.professionalDirections(profession, "kz")}"`;
        } else if (value >= -12 && value <= 0) {
          text = `<br> Мамандықтарға қызығушылық мүлде жоқ "${this.professionalDirections(profession, "kz")}"`;
        }

        outputArrayKZ.push(text);
      }
      let orientationToProfessions = {}

      orientationToProfessions.ru = outputArray.join("; ") + "<br> Развивать мотивацию к общению и коллаборации через преобладающий тип профессии. В каждом случае найдите себе партнеров по интересам чтобы совместно развиваться в данной области, обсуждать темы связанные с типом профессии. Например, если у вас преобладает технические профессии, то найдите себе партнеров по интересам, обсуждайте технические новинки современности, попробуйте что-либо делать вместе в этой теме. Таким образом, вы сможете обмениваться мнениями по интересующей вас теме и развиваться на основе взаимопомощи, получить опыт достижений. Социальные типы профессий предполагают широкий круг общения, интерес к потребностям других людей. Здесь также важно развивать навыки делового общения и умения в делегировании своих полномочий. Также найдите себе тех людей, кому интересен этот тип профессий, пробуйте достигать совместные цели. Гуманитарные профессии предполагают умение работать с документами, точностью передачи фактов, здесь, конечно, нужно развивать критическое мышление, участвовать в дискуссионных клубах. Военно-спортивные – это взаимопомощь совместно развивать навыки конкуренции, дисциплины, но также это умение проигрывать, признавать ошибки. Искусство и культура – найдите себе партнеров по интересам, с которым можно поделиться эстетическими переживаниями. Обсуждайте шедевры, представленные в музеях и новинки современности, попробуйте что-либо делать вместе в этой теме. Образование – найдите себе партнеров по интересам, наблюдайте за навыками учителей, которые вам симпатичны, постоянно развивайте эрудицию в разных областях. Попробуйте что-либо делать вместе в этой теме, готовьте совместные проекты в учебе.";

      orientationToProfessions.kz = outputArrayKZ.join("; ") + "<br> Мамандықтың басым түрі арқылы қарым-қатынас пен ынтымақтастық мотивациясын дамыту. Ол үшін: әр жағдайда осы салада бірге даму үшін мүдделері ұқсас серіктестер тауып, мамандық түріне қатысты тақырыптарды талқылаңыз. Мысалы:<br> - егер сізде «Техникалық» мамандық түрі басым болса, онда осы мамандық түріне қызығушылықтары бар серіктестер табыңыз, сізді қызықтыратын нәрсені талқылаңыз, заманауи техникалық жаңалықтарды талқылаңыз, осы тақырыпта бір нәрсе жасауға тырысыңыз. Осылайша, сіз өзіңізді қызықтыратын тақырып бойынша пікір алмасып, өзара көмек негізінде дами аласыз, жетістіктер тәжірибесін аласыз.<br> - «Әлеуметтік» мамандық түрлері басқа адамдардың қажеттіліктеріне деген қызығушылық пен қарым-қатынастың кең шеңберін қамтиды. Сондай-ақ іскерлік қарым-қатынас дағдыларын және билікті бөлу қабілетін дамыту маңызды. Мамандықтың осы түріне қызығушылық танытатын құрбыларды табыңыз, ортақ мақсаттарға жетуге тырысыңыз.<br> - «Гуманитарлық» мамандықтар құжаттармен және ақпараттармен жұмыс істей білуді және фактілерді нақты сипаттау мен ұсынуды талап етеді. Сізге сыни тұрғыдан ойлауды дамытып, пікірталас клубтарына қатысу қажет.<br> - «Әскери-спорттық» мамандықтар бәсекеге қабілеттілікті, тәртіпті, сонымен қатар жеңіліс пен қателіктерді мойындауды бірлесіп дамытуды көздейді.<br> - «Өнер және мәдениет» - егер сізде мамандықтың осы түрі басым болса, қызығушылықтары ұқсас серіктестер табыңыз, эстетикалық тәжірибелермен бөлісіңіз, мұражайларда ұсынылған жауһарлар мен заманауи жаңалықтарды талқылаңыз, осы тақырыпта бір нәрсе жасауға тырысыңыз.<br> - «Білім» саласы бойынша – мүдделері ұқсас серіктестер табыңыз, сізді қызықтыратын мұғалімдердің дағдыларын байқаңыз, әртүрлі салаларда эрудицияны үнемі дамытыңыз. Осы тақырыпта әрекет етуге тырысыңыз, оқуыңызда бірлескен жобалар дайындаңыз."

      const indexesToSum = [21, 22, 23, 27, 28, 29, 39, 40, 41];
      let score = 0;

      for (const index of indexesToSum) {
        const mark = this.selectProfNew[index]?.mark;
        score += isNaN(mark) ? 0 : Number(mark);
      }

      // интерпритация мотивации к общению и коллаборации

      let motivationCommunicate = {};

      if (score >= 13 && score <= 18) {
        // motivationCommunicate = "У вас выявлен высокий уровень мотивации к общению и коллаборации.";
        motivationCommunicate.ru = "У вас выявлен высокий уровень мотивации к общению и коллаборации.";
        motivationCommunicate.kz = "Сізде қарым-қатынас пен ынтымақтастыққа мотивация жоғары деңгейі анықталды.";
      } else if (score >= 7 && score <= 12) {
        motivationCommunicate.ru = "У вас выявлен средний уровень мотивации к общению и коллаборации.";
        motivationCommunicate.kz = "Сізде бір мамандыққа бағытталу орташа деңгейі анықталды.";
      } else  {
        motivationCommunicate.ru = "У вас выявлен низкий уровень мотивации к общению и коллаборации.";
        motivationCommunicate.kz = "Сізде қарым-қатынас пен ынтымақтастыққа мотивация төмен деңгейі анықталды.";
      }

      const collaborationSendAnswers = [...this.selectProf, scoreProfSum, {score}, {orientationToProfessions}, {motivationCommunicate}]

      const params = {
        answer_type_id: null,
        question_id: null,
        answer_id: {collaborationSendAnswers},
        score,
      }

      localStorage.setItem('quiz-params', JSON.stringify(params))

      console.log('params', params)

      const response = await this.$http.post(API_ROOT + '/api/user-answer/' + quizToken, params)

      if (response.body.status == 'success') {

        Vue.toastr({
          message: this.$t('successful'),
          description: this.$t('saved-successfully'),
          type: 'success'
        })
      } else {
        Vue.toastr({
          message: this.$t('error-title'),
          description: this.$t('error-saving'),
          type: 'error'
        })
      }

      setTimeout(() => {
        this.$router.push({ path: '/about-new/critical-thinking' })
      }, 1500)

    },
    activeChapter(label) {
      if (this.showActiveChapter == label) {
        this.showActiveChapter = ''
      } else {
        this.showActiveChapter = label
      }
    },
    professionalDirections(code, lang) {
        if (code == '01') {
          return lang == "ru" ? "Технические" : "Техникалық"

        } else if (code == '02') {
          return lang == "ru" ? "Социальные" : "Әлеуметтік"

        } else if (code == '03') {
          return lang == "ru" ? "Гуманитарные" : "Гуманитарлық"

        } else if (code == '04') {

          return lang == "ru" ? "Естественно-научные и технологии" : "Жаратылыстану-ғылыми және технологиялық"

        } else if (code == '05') {

          return lang == "ru" ? "Военно-спортивные" : "Әскери-спорттық"

        } else if (code == '06') {

          return lang == "ru" ? "Искусство и культура" : "Өнер және мәдениет"
        } else {

          return lang == "ru" ? "Образование" : "Білім беру"
        }

    },
    startTimer(duration) {
      let timer = duration, minutes, seconds;
      this.timerInterval = setInterval(() => {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        this.countdown = minutes + ":" + seconds;

        let savedTimer = (parseInt(minutes) * 60) + parseInt(seconds);
        localStorage.setItem('timerCollaboration', savedTimer);

        if (--timer < 0) {
          this.sendCollaborationResults()
          clearInterval(this.timerInterval);
          // this.saveAnswer();
          // this.exit();
          // timer = duration;
        }
      }, 1000);
    }
  },
  mounted() {
    if (localStorage.getItem('timerCollaboration')) {
      this.startTimer(localStorage.getItem('timerCollaboration'))
    } else {
      this.startTimer(1200)
    }

    this.orderQuestions = this.shuffleArray([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]);

    let test_lang = localStorage.getItem('test_lang')

    if (test_lang){
      this.$i18n.locale = test_lang;
    }
  }
}
</script>

<style>
.select-custom-collaboration {
  width: 300px !important;
}

.collaboration-desc {
  margin: 20px 0;
}

.collaboration-options {
  cursor: pointer;
  position: relative;
}

.el-select-group__title {
  position: relative;
}

.el-select-group__title::after {
  position: absolute;
  right: 10px;
  top: 2px;
  content: '▼';
}


</style>
